import React, { useState, useEffect } from 'react';
import { Checkbox, Grid, Stack, Text } from 'library/ui';
import { client, consoleLogInDev } from 'shared';

interface ILocationType {
    id: number;
    name: string;
}

interface ILocationTypesProps {
    selectedTypes: number[];
    setSelectedTypes: (val: number[], stringValues?: string[]) => void;
}

export default function LocationTypes({ selectedTypes, setSelectedTypes }: ILocationTypesProps) {
    const [locationTypes, setLocationTypes] = useState<ILocationType[]>([]);

    useEffect(() => {
        client('api/business-location-type/')
            .then((response: ILocationType[]) => {
                setLocationTypes(response);
            })
            .catch(consoleLogInDev);
    }, []);

    function onTypeSelect(id: number) {
        const newSelectedTypes = selectedTypes.includes(id)
            ? selectedTypes.filter((x) => x !== id)
            : [...selectedTypes, id];

        setSelectedTypes(
            newSelectedTypes,
            locationTypes.filter((x) => newSelectedTypes.includes(x.id)).map((x) => x.name),
        );
    }

    if (locationTypes.length === 0) {
        return null;
    }

    return (
        <Stack gap="sm">
            <Text weight="bold">What type of program(s) do you operate?</Text>
            <Grid columns={2} collapseAt="sm" gap="sm">
                {locationTypes.map((x) => (
                    <Checkbox
                        key={x.id}
                        label={x.name}
                        checked={selectedTypes.includes(x.id)}
                        onChange={() => onTypeSelect(x.id)}
                    />
                ))}
            </Grid>
        </Stack>
    );
}
